import { Ruler, Shield, DollarSign, Users, Clock, SunMedium } from "lucide-react";
import Reveal from "@/components/Reveal";

const reasons = [
  {
    icon: Ruler,
    title: "Prep Is Half the Job",
    desc: "Every exterior starts with a full pressure wash and crack repair. Every interior gets masked, patched, and sanded. Paint over dirt is money thrown away.",
    accent: "primary" as const,
  },
  {
    icon: SunMedium,
    title: "Coatings Built for Arizona",
    desc: "We spec UV-resistant acrylics and elastomerics rated for desert heat, so your color holds for years instead of chalking out in two summers.",
    accent: "secondary" as const,
  },
  {
    icon: DollarSign,
    title: "Written Pricing, No Surprises",
    desc: "Free estimates written down before we start. The number you approve is the number you pay — no change orders unless you ask for more work.",
    accent: "primary" as const,
  },
  {
    icon: Clock,
    title: "Open 24 Hours, 7 Days",
    desc: "Call at any hour and someone answers. We schedule around your life and, for businesses, around your open hours — including overnight work.",
    accent: "secondary" as const,
  },
  {
    icon: Shield,
    title: "Licensed & Fully Insured",
    desc: "Your property is protected on every job, from a single accent wall to a full commercial exterior. Ask and we'll send our certificate.",
    accent: "primary" as const,
  },
  {
    icon: Users,
    title: "Family-Run & Bilingual",
    desc: "Owner Alvaro Campos Chacon stands behind every project personally. Friendly service in English and Spanish from first call to final walkthrough.",
    accent: "secondary" as const,
  },
];

const WhyChooseUs = () => {
  return (
    <section className="section-padding bg-accent relative overflow-hidden">
      <div className="absolute inset-0 gradient-mesh opacity-30" />

      <div className="container-max relative z-10">
        <div className="text-center mb-14 md:mb-16">
          <Reveal
            as="span"
            y={10}
            className="inline-block text-tertiary text-sm font-bold uppercase tracking-widest mb-3"
          >
            Why 4 Seasons Painting
          </Reveal>
          <Reveal
            as="h2"
            y={20}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-accent-foreground mb-4 tracking-tight font-bold"
          >
            Why Choose <span className="text-gradient-brand">Us</span>
          </Reveal>
          <Reveal
            as="p"
            y={15}
            delay={0.1}
            className="text-accent-foreground/70 max-w-2xl mx-auto text-lg"
          >
            Six reasons homeowners and businesses across the Valley hand us the keys and the paint deck.
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((reason, i) => (
            <Reveal
              as="div"
              y={30}
              delay={i * 0.08}
              duration={0.5}
              key={reason.title}
              className="glass-card rounded-2xl p-6 md:p-8 card-hover-lift"
            >
              <div className={`inline-flex items-center justify-center h-14 w-14 rounded-2xl mb-5 ${
                reason.accent === "secondary"
                  ? "bg-tertiary/25 text-tertiary"
                  : "bg-primary/30 text-white"
              }`}>
                <reason.icon className="h-7 w-7" />
              </div>
              <h3 className="font-heading text-xl text-accent-foreground mb-2 tracking-tight font-bold">{reason.title}</h3>
              <p className="text-accent-foreground/70 text-sm leading-relaxed">{reason.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
